import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '訪問介護サービスを利用するにはどうすればいいですか？',
      answer: 'まずは担当のケアマネージャーにご相談ください。ケアマネージャーがいない場合は、お住まいの地域包括支援センターまたは当事業所に直接お問い合わせください。介護保険の申請から丁寧にサポートいたします。',
    },
    {
      question: '岡山市北区以外でもサービスを利用できますか？',
      answer: '当事業所は岡山市北区を中心にサービスを提供しておりますが、近隣地域についてもご相談に応じます。まずはお気軽にお問い合わせください。',
    },
    {
      question: 'サービスの利用時間や曜日は選べますか？',
      answer: 'はい、お客様のご都合に合わせて柔軟に対応いたします。早朝・夜間のサービスも可能です。ケアプラン作成時にご希望をお聞かせください。',
    },
    {
      question: '急な依頼にも対応してもらえますか？',
      answer: '可能な限り対応いたします。緊急時や急な体調変化の際は、まずはお電話でご相談ください。スタッフの調整を行い、できる限り早く対応させていただきます。',
    },
    {
      question: '同じヘルパーさんに来てもらえますか？',
      answer: 'はい、できる限り同じヘルパーが訪問するよう調整いたします。信頼関係を築きながら、安心してサービスをご利用いただけるよう配慮しております。',
    },
    {
      question: '家族が不在でもサービスを受けられますか？',
      answer: 'はい、ご家族が不在でも問題ございません。鍵のお預かりなど、安全面に配慮した対応も可能です。サービス内容は定期的にご家族へ報告いたします。',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-4 px-4">
            よくあるご質問
          </h2>
          <p className="text-base sm:text-lg text-navy-700 px-4">
            岡山市北区の訪問介護サービスについてよくいただくご質問
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="bg-beige-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 sm:p-6 text-left hover:bg-beige-100 transition-colors cursor-pointer"
              >
                <span className="text-base sm:text-lg font-bold text-navy-800 pr-4 leading-snug">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-coral-500 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-sm sm:text-base text-navy-700 leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12 text-center"
        >
          <p className="text-base text-navy-700 mb-6 px-4">
            その他のご質問やご不明な点がございましたら、お気軽にお問い合わせください
          </p>
          <a
            href="tel:086-012-3456"
            className="inline-flex items-center space-x-2 bg-coral-500 text-white px-8 py-4 rounded-full hover:bg-coral-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-medium"
          >
            <i className="ri-phone-line text-xl"></i>
            <span>086-012-3456</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;